import React from 'react';
import { Heart, MapPin, Stethoscope } from 'lucide-react';

const LoadingSpinner = ({ 
  size = 'md', 
  variant = 'default',
  text = 'Loading...',
  showText = true,
  className = '' 
}) => {
  
  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6', 
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg', 
    xl: 'text-xl'
  };

  if (variant === 'pulse') {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div className="relative">
          <Heart 
            size={size === 'xl' ? 48 : size === 'lg' ? 36 : size === 'md' ? 24 : 20} 
            className="text-red-500 animate-pulse" 
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-red-600 rounded-full animate-ping"></div>
          </div>
        </div>
        {showText && (
          <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
            {text}
          </p>
        )}
      </div>
    );
  }

  if (variant === 'medical') {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div className="relative">
          <Stethoscope 
            size={size === 'xl' ? 48 : size === 'lg' ? 36 : size === 'md' ? 24 : 20}
            className="text-blue-600 animate-bounce"
          />
          <div className="absolute -top-1 -right-1">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-ping"></div>
          </div>
        </div>
        {showText && (
          <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
            {text}
          </p>
        )}
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
        {showText && (
          <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
            {text}
          </p>
        )}
      </div>
    );
  }

  if (variant === 'location') {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div className="relative">
          <MapPin 
            size={size === 'xl' ? 48 : size === 'lg' ? 36 : size === 'md' ? 24 : 20}
            className="text-green-600 animate-pulse"
          />
          <div className="absolute inset-0 animate-ping">
            <MapPin 
              size={size === 'xl' ? 48 : size === 'lg' ? 36 : size === 'md' ? 24 : 20}
              className="text-green-300 opacity-75"
            />
          </div>
        </div>
        {showText && (
          <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
            {text}
          </p>
        )}
      </div>
    );
  }

  if (variant === 'bars') {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div className="flex space-x-1">
          {[...Array(4)].map((_, i) => (
            <div 
              key={i}
              className="w-1 bg-blue-600 animate-pulse"
              style={{ 
                height: '20px',
                animationDelay: `${i * 100}ms`,
                animationDuration: '1s'
              }}
            ></div>
          ))}
        </div>
        {showText && (
          <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
            {text}
          </p>
        )}
      </div>
    );
  }

  // Default spinner
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin ${sizes[size]}`}></div>
      {showText && (
        <p className={`mt-3 text-gray-600 font-medium ${textSizes[size]}`}>
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;